import React from "react";
import { Box } from "@mui/material";
import CustomTextField from "./CustomTextField";

const ArticuloInfo = ({ articulo, loading = false }) => {
  return (
    <Box width={310} mb={2}>
      <CustomTextField label="ARTÍCULO" value={articulo?.descripcion || ""} disabled loading={loading} />

      <CustomTextField label="CÓDIGO DE BARRAS" value={articulo?.codigoBarra || ""} disabled loading={loading} />
    </Box>
  );
};

export default ArticuloInfo;
